import React, {useEffect, useRef, useState} from 'react'
import {useHistory} from 'react-router-dom'
import Select from 'react-select'
import axios from 'axios'
import Cookies from 'js-cookie'

import * as constants from 'constants/index.js'
import CardsHeader from 'layouts/Headers/CardsHeader.js'
import notify from '@utils/notify'

import {Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Row} from 'reactstrap'

export default function LiveVehicleCreate() {
  const history = useHistory()

  const [token, setToken] = useState('')
  const [regNos, setRegNos] = useState([])
  const [filter, setFilter] = useState('')

  const createVehicle = async () => {    
    try {
      const response = await axios({
        method: 'POST',
        url: `${constants.API_URL}/live-vehicles/${filter.regNo}`,
        headers: {
          Authorization: `Bearer ${token}`,
        }
      })

      const data = response.data

      if(data.success === true) {
        console.log(data.message)
        notify.success(data.message)
        setTimeout(() => goList(), 2000)
      }
    } catch (error) {
      console.error('error :: ', error)
      notify.warning(error.response ? error.response.statusText : 'Error occurred!')
    }
  }

  useEffect(() => {
    const grs_token = Cookies.get('grs_token')
    setToken(grs_token)

    const source = axios.CancelToken.source()

    const fetchData = async () => {
      try {
        const response = await axios({
          method: 'GET',
          url: `${constants.API_URL}/live-vehicles/create`,
          headers: {
            Authorization: `Bearer ${grs_token}`,
          },
          cancelToken: source.token,
        })
        console.log('response :: ', response.data)
        const data = response.data

        let _regNos = data.data.regNos;
        let _regNos_array = [];
        _regNos.map(_regNo => {
          return _regNos_array.push({
            ..._regNo,
            value: _regNo.id,
            label: _regNo.stock_no,
          })
        })
        setRegNos(_regNos_array)
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Request canceled :: ', error)
        } else {
          console.error('error :: ', error)
          notify.warning(error.response ? error.response.statusText : 'Error occurred!')
        }
      }
    }

    fetchData()

    return () => {
      source.cancel()
    }
  }, [])

  const goList = () => {
    history.push({
      pathname: '/admin/live-vehicle/master'
    })
  }

  return (
    <>
      <CardsHeader name="Fleets" parentName="Job Management" currentName="Create" />
      <Container className="mt--5 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col xs={8}>
                    <h1 className="mb-0">Master vehicles management</h1>
                  </Col>
                  <Col xs={4} className="text-right">
                    <Button className="w-100" color="success" type="button" onClick={() => goList()}>Back to list</Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Container>
                  <Row>
                    <Col md={4} sm={12} xs={12}>
                      <FormGroup>
                        <label className="form-control-label">Reg No</label>
                        <Select
                          options={regNos}
                          value={filter && filter.regNo ? (regNos.find((element) => element.id === filter.regNo) || '') : ''}
                          onChange={value => setFilter({
                            ...filter,
                            regNo: value.id
                          })}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4} sm={12} xs={12} className="pt-3-4">
                      <Button className="w-100" color="success" style={{margin: 5, padding: '0.425rem 1.25rem', }} type="button" onClick={() => createVehicle()}>Create</Button>
                    </Col>
                  </Row>
                </Container>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}